import { render, staticRenderFns } from "./OverviewListItem.vue?vue&type=template&id=4a05c0c4"
import script from "./OverviewListItem.vue?vue&type=script&lang=js"
export * from "./OverviewListItem.vue?vue&type=script&lang=js"
import style0 from "./OverviewListItem.vue?vue&type=style&index=0&id=4a05c0c4&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports